export default __webpack_public_path__ + "static/media/nodejs.595ee526.svg";